import { render, staticRenderFns } from "./BaseDocumentation.vue?vue&type=template&id=c9e18df2&"
import script from "./BaseDocumentation.vue?vue&type=script&lang=js&"
export * from "./BaseDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports